/**
 * Mobile Boost PFS filter: make the vendor's close control (an <a href="javascript:;">)
 * keyboard-operable (Enter + Space), expose role="button", and keep it in the tab order
 * without replacing the node (Boost binds click on this element).
 */
(function () {
  var CLOSE_SEL = '.boost-pfs-filter-close';

  function enhance(el) {
    if (!el || el.nodeType !== 1 || el._mgBoostCloseA11y) return;
    if (!el.matches || !el.matches(CLOSE_SEL)) return;

    el._mgBoostCloseA11y = true;

    el.setAttribute('role', 'button');
    var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (label && !el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', label);
    }

    if (el.tagName === 'A') {
      el.removeAttribute('href');
      el.setAttribute('tabindex', '0');
    } else if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    el.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      },
      false
    );
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CLOSE_SEL).forEach(enhance);
  }

  var debounceTimer;
  function scheduleScan(target) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (target && target.nodeType === 1) {
        if (target.matches && target.matches(CLOSE_SEL)) enhance(target);
        scan(target);
      } else {
        scan(document);
      }
    }, 0);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) scheduleScan(n);
        }
      }
    }
  });

  function startObserver() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
      startObserver();
    });
  } else {
    scan(document);
    startObserver();
  }

  window.addEventListener('load', function () {
    scheduleScan(document.documentElement);
  });

  document.addEventListener(
    'click',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.boost-pfs-filter-tree-mobile-button')) {
        scheduleScan(document.documentElement);
      }
    },
    true
  );

  [400, 2000, 4500].forEach(function (ms) {
    setTimeout(function () {
      scheduleScan(document.documentElement);
    }, ms);
  });

  window.MG_BOOST_PFS_FILTER_CLOSE_A11Y = {
    refresh: function () {
      scheduleScan(document.documentElement);
    }
  };
})();
